"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
require("antd/lib/modal/style");
var _modal = _interopRequireDefault(require("antd/lib/modal"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = require("../Icon");
require("./Modal.less");
var _lodash = require("lodash");
var _excluded = ["visible", "onClose", "children", "bodyStyle", "closeStyles"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var Modal = function Modal(_ref) {
  var visible = _ref.visible,
    onClose = _ref.onClose,
    children = _ref.children,
    bodyStyle = _ref.bodyStyle,
    closeStyles = _ref.closeStyles,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_modal.default, _extends({
    className: "CustomAntdModalStyle",
    visible: visible,
    bodyStyle: (0, _lodash.defaults)(bodyStyle, {
      padding: '20px'
    }),
    footer: null,
    closable: false,
    onCancel: onClose
  }, props), onClose && /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full relative"
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    type: "close-24",
    size: 24,
    className: (0, _classnames.default)('absolute right-0 cursor-pointer text-black z-1', closeStyles),
    onClick: onClose
  })), children);
};
exports.Modal = Modal;